import type { FlowStepRef } from '@footsteps/shared';

/**
 * Entity wrapping the jsonb `flow` column on the `cases` table.
 */
export class WozCaseFlowEntity {
  steps: FlowStepRef[];
  currentStepIndex: number;
  completedSteps: FlowStepRef[];
  isWaitingForTrigger: string | null;
  isWaitingForInput: boolean;

  constructor(data: Partial<WozCaseFlowEntity> = {}) {
    this.steps = data.steps ?? [];
    this.currentStepIndex = data.currentStepIndex ?? 0;
    this.completedSteps = data.completedSteps ?? [];
    this.isWaitingForTrigger = data.isWaitingForTrigger ?? null;
    this.isWaitingForInput = data.isWaitingForInput ?? false;
  }

  toJSON() {
    return {
      steps: this.steps,
      currentStepIndex: this.currentStepIndex,
      completedSteps: this.completedSteps,
      isWaitingForTrigger: this.isWaitingForTrigger,
      isWaitingForInput: this.isWaitingForInput,
    };
  }
}
